<template>
  <div class="config_layout_style">
    <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
    <div class="config_title_style">收货地址</div>
    <div v-if="userAddress == null" class="address_style">
      <div class="detail_style">
        <el-cascader
          size="large"
          :options="pcaTextArr"
          v-model="selectedOptions"
          @change="handleChange"
        >
        </el-cascader>
      </div>
      <div class="detail_style">
        <el-input v-model="address" placeholder="详细地址" />
      </div>
      <!-- 
      <div class="detail_style">
        <el-input v-model="receiving" placeholder="收件人" />
      </div>
      <div class="detail_style">
        <el-input v-model="receivingMobile" placeholder="收件人手机" />
      </div>
       -->
      <!-- <el-button
        type="primary"
        plain
        class="address_button_style"
        @click="addressInsert"
        >保存</el-button
      > -->
      <div class="family_style" @click="addressInsert">保存</div>
    </div>
    <div v-else>
      <el-descriptions :column="1" :colon="false" border>
        <el-descriptions-item label="省">{{
          userAddress.province
        }}</el-descriptions-item>
        <el-descriptions-item label="市">{{
          userAddress.city
        }}</el-descriptions-item>
        <el-descriptions-item label="区">{{
          userAddress.district
        }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{
          userAddress.address
        }}</el-descriptions-item>
        <el-descriptions-item label="收件人">{{
          userAddress.receiving
        }}</el-descriptions-item>
        <el-descriptions-item label="收件人手机">{{
          userAddress.receivingMobile
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>
<script>
import { pcaTextArr } from "element-china-area-data";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      province: null,
      city: null,
      district: null,
      address: null,
      // receiving: null,
      // receivingMobile: null,
      pcaTextArr,
      selectedOptions: [],
      userAddress: null,
    };
  },
  mounted() {
    this.getAddress();
  },
  methods: {
    goBack() {
      // this.$router.back();
      this.$router.push({
        path: "/menu",
      });
    },
    handleChange(value) {
      this.province = value[0];
      this.city = value[1];
      this.district = value[2];
    },
    getAddress() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmAddress/get", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data != null) {
            this.userAddress = res.data.data;
          }
        });
    },
    addressInsert() {
      if (this.province == null || this.province == "") {
        this.$message({
          type: "error",
          message: "请选择省市区",
        });
        return;
      }
      if (this.address == null || this.address == "") {
        this.$message({
          type: "error",
          message: "请输入地址",
        });
        return;
      }
      // if (this.receiving == null || this.receiving == "") {
      //   this.$message({
      //     type: "error",
      //     message: "请输入收件人",
      //   });
      //   return;
      // }
      // if (this.receivingMobile == null || this.receivingMobile == "") {
      //   this.$message({
      //     type: "error",
      //     message: "请输入收件人手机",
      //   });
      //   return;
      // }
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .post("/cgmAddress/save", {
          userId,
          province: this.province,
          city: this.city,
          district: this.district,
          address: this.address,
          // receiving: this.receiving,
          // receivingMobile: this.receivingMobile,
        })
        .then((res) => {
          this.getAddress();
          this.$message({ type: "success", message: "添加成功" });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width:768px) {
  .config_layout_style {
    padding: 40px;
  }
}
@media (min-width:768px) {
  .pc_hide_style {
    display: none;
  }
}
.family_style {
  width: 162px;
  height: 42px;
  border-radius: 21px;
  background: #e0000f;
  color: #fff;
  line-height: 42px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.config_title_style {
  font-size: 22px;
  color: #202f3b;
  font-weight: bold;
  margin-bottom: 25px;
}
.address_style {
  // margin-bottom: 40px;
  background: #fff;
  border-radius: 10px;
  padding: 40px 0 40px 0;
}
.detail_style {
  margin-bottom: 20px;
  // margin-left: 20px;
}
.detail_style ::v-deep .el-input__inner {
  width: 320px;
}
</style>